import { useState, useMemo, useEffect } from 'react';
import { getFormByID, addFieldsToFormTable , removeFieldToFormTable } from '../../../../services/firebase/form/formTable';
import { capitalizeObjKeys, lowerCaseStringFirstLetter, upperCaseStringFirstLetter } from '../../../../utils/utilities';
import { useParams , useLocation} from 'react-router-dom';
import { DB_fieldName, fieldName2, formFields, tbColumns } from './const';
import { ALERT_TYPE } from '../../../../constants/alert-type';
import { IconButton } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

const useFieldsCreatorPage = () => {
    const { formId } = useParams();
    const [formFieldState, setformFieldState] = useState({});
    const [formName, setFormName] = useState([]);
    const [formExists, setFormExists] = useState(false);
    const [tableColumns, setTableColumns] = useState([]);
    const [tableItems, setTableItems] = useState([]);
    const [showAlert, setShowAlert] = useState({ show: false, message: "", severity: "" });
    const [fields] = useState(formFields);
    const location = useLocation();

    let TABLE_NAME = "PDFTemplates"
    if(location.pathname.includes('/main/')){
        TABLE_NAME = "MainFields"
    }

    useEffect(() => {
        setTableColumns(tbColumns);
        getForms();
    }, [])

    useEffect(() => {
        getForms();
    }, [formExists])

    //get All data from Forms Table
    const getForms = async () => {
        try {
            const data = await getFormByID(formId , TABLE_NAME);
            
            if (TABLE_NAME === "Forms" && data.FormName) 
                {setFormName(`${data.FormName} (${data.Form} - ${data.Type})`)} 
            else 
                { setFormName(`${data.Form} - ${data.Type}`) }

            setFormExists(true)

            //manipulate data to be displayed in Table
            const tbItems = await createTableItemsData(data[DB_fieldName]);
            setTableItems(tbItems);
        } catch (error) {
            console.log(error)
            setFormExists(false)
            callAlertBar(true, `Form ID: ${formId} does not exist.`, ALERT_TYPE.ERROR)

        }
    }

    const handleFieldChange = (val, field) => {
        if (field === fieldName2.fieldName ) {
            setformFieldState({ ...formFieldState, [field]: val, [field + "2"]: setBackEndName(val) })
        } else if (field === fieldName2.fieldOptions) {
            setformFieldState({ ...formFieldState, [field]: val.split(",") })
        } else {
            setformFieldState({ ...formFieldState, [field]: val })
        }
    }

    const createTableItemsData = (fieldsItems) => {
        let tbItems = []
        try {
            if (fieldsItems) {
                const sortedItems = fieldsItems.slice().sort((a, b) => {
                    const sectionA = a.FieldSection || "";
                    const sectionB = b.FieldSection || "";
                    // First, sort by FieldSection
                        if (sectionA !== sectionB) {
                            return sectionA.localeCompare(sectionB);
                        }
                        // If FieldSection is the same, compare by FieldOrder
                        return parseInt(a.FieldOrder) - parseInt(b.FieldOrder);
                });

                sortedItems.forEach(item => {
                    tbItems.push(createTableData(
                        item.FieldName,
                        item.FieldName2,
                        item.FieldType,
                        item.FieldOrder,
                        item.FieldSize,
                        item.FieldSection,
                        item.IsRequired ? "Yes" : "No",
                        item.Disabled ? "Yes" : "No",
                        item.Formula ,
                        <IconButton
                        size="large"
                        aria-haspopup="true"
                        key={item.FieldName2}
                        onClick={() => buttonAction.handleDelete(item.FieldName2)}
                    >
                        <DeleteForeverOutlinedIcon sx={{ color: 'error.main' }} />
                    </IconButton>
                    ))
                });
            }
        } catch (error) {
            console.log(error)
            callAlertBar(true, `The form ID: ${formId} you entered appears to be problematic. <br/><br/> It's possible that the form doesn't exist or has been deleted.`, ALERT_TYPE.ERROR)
        }

        return tbItems;

    }

    const createTableData = (fieldName, fieldName2, fieldType, fieldOrder, fieldSize, fieldSection, isRequired , disabled, formula,action) => {
        return { fieldName,fieldName2 ,fieldType, fieldOrder, fieldSize, fieldSection, isRequired , disabled ,  formula,action};
    }

    const buttonAction = {
        handleSubmit: async () => {
            const fieldObj = capitalizeObjKeys(formFieldState);
            fieldObj.IsRequired === "Yes" ? fieldObj.IsRequired = true : fieldObj.IsRequired = false
            fieldObj.Disabled === "Yes" ? fieldObj.Disabled = true : fieldObj.Disabled = false
            try {
                await addFieldsToFormTable(fieldObj, formId, DB_fieldName , TABLE_NAME);
                callAlertBar(true, "Your action was successful!", ALERT_TYPE.SUCCESS)

            } catch (error) {
                callAlertBar(true, error, ALERT_TYPE.ERROR)
            }
            // setformFieldState({})
            setFormExists(false)
            setTimeout(() => {
                setFormExists(true)
            }, 100)
        },
        handleDelete: async (fieldName) => {
            await removeFieldToFormTable(fieldName, formId, DB_fieldName , TABLE_NAME);
            callAlertBar(true, "Field successfully deleted!", ALERT_TYPE.SUCCESS)
            setFormExists(false)
            setTimeout(() => {
                setFormExists(true)
            }, 100)

        },
        // handleCopy: async () => {
        //     const data = await getFormByID(formId , TABLE_NAME);
        //     for( const field in data.Fields) {
        //         // console.log(data.Fields[field]);
        //         await addFieldsToFormTable(data.Fields[field], 'mj9sKtK5UYVPcyGC6zrd', DB_fieldName , TABLE_NAME);
        //     }
        //     // await addFieldsToFormTable(fields, 'mj9sKtK5UYVPcyGC6zrd', DB_fieldName , TABLE_NAME);
        // }
    }

    const callAlertBar = (show, message, severity) => {
        setShowAlert({ show: show, message: message, severity: severity });
        if(severity !== ALERT_TYPE.ERROR){
            setTimeout(() => {
                setShowAlert({ ...showAlert, show: false });
            }, 5000)
        }
        
    }

    const setBackEndName = (string) => {
        const newStringVal = string.replace(/[^\w\s]/gi, '')
        const splitString = newStringVal.split(" ");
        const newString = splitString.map((item, key) => {
            if (item !== " ") {
                if (key === 0) {
                    return lowerCaseStringFirstLetter(item)
                } else {
                    return upperCaseStringFirstLetter(item)
                }
            }

        });
        return newString.toString().replaceAll(",", "");
    }

    return {
        formFieldState,
        buttonAction,
        fields,
        handleFieldChange,
        formName,
        formExists,
        tableColumns,
        tableItems,
        showAlert
    }
}

export default useFieldsCreatorPage;